import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";
import { Add } from "@mui/icons-material";
import { createInstructor } from "../../../../hooks/manageInstructorsLocations";
import { useDispatch } from "react-redux";
import { enqueueErrorSnackbar } from "../../../../redux/actions/snackbarActions";
import EditInstructorModal from "./EditInstructorModal";
import { instructorTypes } from "../../../../constants/index";
import MenuButton from "../../../../components/Buttons/MenuButton";

const AddInstructorButton = ({ onSave, buttonProps }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { createNewInstructor, isSubmitting } = createInstructor();

  const [instructorType, setInstructorType] = useState(
    instructorTypes.internal
  );
  const [editInstructorModalOpen, setEditInstructorModalOpen] = useState(false);

  const handleAddNewInstructor = instructorData => {
    if (!isSubmitting) {
      return createNewInstructor({
        ...instructorData,
        isExternal: !instructorData.userId
      }).then(response => {
        if (response.email && response.email.length > 0) {
          // Duplicate instructor was added
          dispatch(enqueueErrorSnackbar({ message: response.email[0] }));
        } else {
          setEditInstructorModalOpen(false);
          onSave();
        }
      });
    }
  };

  const handleSaveInstructor = instructorData =>
    handleAddNewInstructor(instructorData);

  const handleCloseEditInstructorModal = () => {
    setEditInstructorModalOpen(false);
  };

  const handleAddNewInstructorClick = instructorType => {
    setInstructorType(instructorType);
    setEditInstructorModalOpen(true);
  };

  return (
    <>
      <MenuButton
        startIcon={<Add />}
        onClick={handleAddNewInstructorClick}
        menuItems={Object.values(instructorTypes).map(instructorType => ({
          label: t("editInstructorModal.instructorType", {
            context: instructorType
          }),
          value: instructorType
        }))}
        {...buttonProps}
      >
        {t("courses.manageInstructors.addNew")}
      </MenuButton>
      <EditInstructorModal
        open={editInstructorModalOpen}
        onClose={handleCloseEditInstructorModal}
        onSave={handleSaveInstructor}
        defaultInstructorType={instructorType}
      />
    </>
  );
};

export default AddInstructorButton;

AddInstructorButton.propTypes = {
  onSave: PropTypes.func,
  // Props to be passed to Material UI button
  buttonProps: PropTypes.object
};
